// frontend/src/storage/localStorage.js

import { sanitizeAuthToken } from "../services/common";

const PERSIST_ROOT_KEY = "persist:root";
const PERSISTED_REDUCER_KEY = "persistedReducer";
const TOKEN_KEY = "token";

const parseJson = (value) => {
  if (!value) {
    return null;
  }

  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
};

const readPersistRoot = () => parseJson(localStorage.getItem(PERSIST_ROOT_KEY));

const readPersistedReducer = (persistRoot) => {
  if (!persistRoot) {
    return null;
  }

  return parseJson(persistRoot[PERSISTED_REDUCER_KEY]);
};

const writePersistedReducer = (persistRoot, persistedReducer) => {
  const nextPersistRoot = {
    ...(persistRoot ?? {}),
    [PERSISTED_REDUCER_KEY]: JSON.stringify(persistedReducer ?? {}),
  };

  localStorage.setItem(PERSIST_ROOT_KEY, JSON.stringify(nextPersistRoot));

  return nextPersistRoot;
};

export const getToken = () => {
  const persistRootValue = localStorage.getItem(PERSIST_ROOT_KEY);
  const persistRoot = parseJson(persistRootValue);

  if (!persistRoot) {
    return null;
  }

  const persistedReducerValue = persistRoot[PERSISTED_REDUCER_KEY];
  const persistedReducer = parseJson(persistedReducerValue);

  if (!persistedReducer) {
    return null;
  }

  return persistedReducer[TOKEN_KEY] ?? null;
};

export const getData = (name) => {
  if (name === TOKEN_KEY) return getToken();
  return localStorage.getItem(name);
};

export const setData = (name, newValue) => {
  return localStorage.setItem(name, newValue);
};

export const persistToken = (token) => {
  const sanitizedToken = sanitizeAuthToken(token);

  if (!sanitizedToken) {
    clearToken();
    return;
  }

  const persistRoot = readPersistRoot();
  const persistedReducer = readPersistedReducer(persistRoot) ?? {};

  persistedReducer[TOKEN_KEY] = sanitizedToken;

  writePersistedReducer(persistRoot, persistedReducer);
};

export const clearToken = () => {
  const persistRoot = readPersistRoot();
  const persistedReducer = readPersistedReducer(persistRoot);

  if (!persistedReducer || !(TOKEN_KEY in persistedReducer)) {
    return;
  }

  delete persistedReducer[TOKEN_KEY];

  writePersistedReducer(persistRoot, persistedReducer);
};
